<template>
    <div style="margin-top: 10px">
        <div class="row">
            <div class="col-md-12">
                <label>DNI</label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <base-input v-model="model.Aux2" @blur="change" @change="change" :maxlength="8"></base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <money-with-indicator v-model="model.Importe" v-on:blur="change" v-on:validatedOK="onSaldoOK"/>
            </div>
        </div>
    </div>
</template>

<script>
    import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

    export default {
        components: {
            "money-with-indicator": MoneyWithIndicator
        },
        props: {
            model: {
                        Aux1:1,
                        Aux2:'',
                        Aux3:'',
                        Aux4:'',
                        Importe:0,
                        Validate:false,
                        Errors:[]
                }
        },    
        data() {
            return {
                
            }
        }, 
methods: {
            change(element){
                    this.validate();
                    this.$emit('input', this.model);
            },
            validate(){
                let context = this;
                context.model.Errors = [];

                if(context.model.Aux2.length < 6 || context.model.Aux2.length > 8){
                    context.model.Validate = false;
                    context.model.Errors.push("El dni debe tener entre 6 y 9 caracteres");
                }
                else if(context.model.Importe <= 0)
                {
                    context.model.Validate =false;
                    context.model.Errors.push("El importe no puede ser menor que 0");
                }
                else{
                    context.model.Validate = true;
                }
            },
            onSaldoOK(val) {
                this.$emit("saldoOK", val);
            }
        }
    }
</script>